import { Headline, Container, BrownRectangle } from "./styles";
import { Paragraph } from "../../../lib/Font/styles";
import { middleBottomAnimationProps, quickBottomAnimationProps } from "../../functionallity/animationProps";

interface TopicIntroProps {
    headline: React.ReactNode;
    introductionText: React.ReactNode;
}

const TopicIntro: React.FC<TopicIntroProps> = ({ headline, introductionText }) => {
    return (
        <Container>
            <Headline {...quickBottomAnimationProps} lang="de">
                {headline}
            </Headline>
            <BrownRectangle {...quickBottomAnimationProps}/>
            <Paragraph {...middleBottomAnimationProps} lang="de">
                {introductionText}
            </Paragraph>
        </Container>
    );
}

export default TopicIntro;
